<template>
  <q-card bordered class="q-mt-md q-pa-md shadow-1" style="max-width: 90vw">
    <q-card-section class="row text-green-vito no-wrap justify-between">
      <div class="text-h6">
        {{ $t("title.addPromotion") }}
      </div>
      <q-btn icon="close" flat round dense v-close-popup />
    </q-card-section>
    <q-card-section class="q-gutter-md">
      <q-input
        ref="amount"
        stack-label
        clearable
        square
        filled
        type="number"
        :suffix="currency"
        :label="$t('label.amount')"
        v-model.number="amount"
        lazy-rules
        :rules="[required, isAmount]"
      >
        <template v-slot:prepend> <q-icon name="payments" /> </template>
      </q-input>
      <q-input
        ref="endDate"
        stack-label
        square
        filled
        type="date"
        :label="$t('label.endDate')"
        v-model="endDate"
        lazy-rules
        :rules="[required]"
      >
        <template v-slot:prepend> <q-icon name="event" /> </template>
      </q-input>
    </q-card-section>

    <q-card-actions class="q-pa-md justify-end">
      <q-btn
        unelevated
        size="md"
        class="text-green-vito"
        :label="$t('button.cancel')"
        v-close-popup
      />
      <q-btn
        unelevated
        size="md"
        class="bg-green-vito text-white"
        :label="$t('button.save')"
        :disable="!amount || !endDate"
        @click="handleSave"
      />
    </q-card-actions>
  </q-card>
</template>

<script>
import PromotionApi from "../../apis/Promotion";
export default {
  props: ["store"],
  emits: ["refresh"],

  data: () => {
    return {
      amount: null,
      endDate: null,
    };
  },

  methods: {
    required(val) {
      return (
        (val !== null && val !== undefined && val !== "") ||
        this.$t("validation.required")
      );
    },
    isAmount(val) {
      return (
        (!isNaN(val) && val >= 0 && val <= 100) ||
        this.$t("validation.amountRange")
      );
    },
    async handleSave() {
      this.errorMessage = null;

      try {
        const promotionResponse = await PromotionApi.create({
          storeId: this.store.id,
          amount: this.amount,
          endDate: this.endDate,
        });

        this.$q.notify({
          type: "positive",
          message: this.$t(promotionResponse.data.message),
        });
        this.$emit("refresh");
      } catch (error) {
        const message = error.response
          ? error.response.data.message
          : error.message;
        this.errorMessage = message;
        this.$q.notify({
          type: "negative",
          message: message,
        });
      }
    },
  },

  computed: {
    currency() {
      return this.$store.getters.currency;
    },
  },
};
</script>
